export enum ArtistSource {
    System = 1,
    User = 2
}
export interface Artist {
    artistId: number;
    artistName: string;
    birthDate?: string | null;
    deathDate?: string | null;
    artistPeriod?: string | null;
    countryCode?: string;
    biography?: string;
    countryName?: string;
    source: ArtistSource;
    artworkCount?: number;
    clientBio?: string;
    nationality?: string;
}

export interface CreateArtistRequest {
    artistName: string;
    birthDate?: string | null;
    deathDate?: string | null;
    artistPeriod?: string | null;
    countryCode?: string;
    biography?: string;
}

export interface Country {
    countryCode: string;
    countryName: string;
}

export interface ArtistSearchResult {
    artistId: number;
    artistName: string;
    birthDate?: string;
    deathDate?: string;
    artistPeriod?: string;
    countryCode?: string;
    countryName?: string;
    nationality?: string;
    source: ArtistSource;
    isAlreadyAssigned: boolean;
}

export interface AssignArtistRequest {
    artistId: number;
    clientNotes?: string;
    clientBiography?: string;
}